import { isNullOrUndefined } from 'util';
import { __extends, __awaiter, __generator, __assign, __read, __spread } from 'tslib';
import { FormControl, FormBuilder, FormArray, FormGroup } from '@angular/forms';
import { classToClass, plainToClass } from 'class-transformer';
import 'reflect-metadata';
import { validate, getFromContainer, MetadataStorage, Validator, ValidationTypes, validateSync } from 'class-validator';
import { BehaviorSubject, Subject } from 'rxjs';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} options
 * @return {?}
 */
function isDynamicFormGroupConfig(options) {
    return options && !isNullOrUndefined(options['customValidatorOptions']);
}
/**
 * @param {?} options
 * @return {?}
 */
function isLegacyOrOpts(options) {
    return options && (!isNullOrUndefined(options['validator']) || !isNullOrUndefined(options['asyncValidator']));
}
/**
 * @param {?} options
 * @return {?}
 */
function isAbstractControlOptions(options) {
    return (options &&
        (!isNullOrUndefined(options.validators) ||
            !isNullOrUndefined(options.asyncValidators) ||
            !isNullOrUndefined(options.updateOn)));
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} c
 * @return {?}
 */
function foreverInvalid(c) {
    return {
        foreverInvalid: {
            valid: false
        }
    };
}
/** @type {?} */
var FOREVER_INVALID_NAME = 'foreverInvalid';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DynamicFormControl = /** @class */ (function (_super) {
    __extends(DynamicFormControl, _super);
    function DynamicFormControl(fieldDefinition) {
        var _this = _super.call(this, fieldDefinition.data, fieldDefinition.validationFunctions) || this;
        _this.validationDefinitions = fieldDefinition.validationDefinitions;
        return _this;
    }
    return DynamicFormControl;
}(FormControl));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var cloneDeep = require('lodash.clonedeep');
/** @type {?} */
var mergeWith = require('lodash.mergewith');
/**
 * @template TModel
 */
var  /**
 * @template TModel
 */
DynamicFormGroup = /** @class */ (function (_super) {
    __extends(DynamicFormGroup, _super);
    function DynamicFormGroup(factoryModel, fields, validatorOrOpts, asyncValidator) {
        var _this = _super.call(this, {}, validatorOrOpts, asyncValidator) || this;
        _this.factoryModel = factoryModel;
        _this.fields = fields;
        _this.nativeValidateErrors = new BehaviorSubject({});
        _this.customValidateErrors = new BehaviorSubject({});
        _this.objectChange = new Subject();
        _this._fb = new FormBuilder();
        /*
        const classValidators = DynamicFormGroup.getClassValidators<TModel>(
          this.factoryModel,
          this.fields,
          this.defaultValidatorOptions
        );
        const formGroup = this._fb.group(
          classValidators
        );
        Object.keys(formGroup.controls).forEach(key => {
          this.addControl(key, formGroup.controls[key]);
        });
        this.valueChanges.subscribe(data => {
          this.validate(
            undefined,
            this.defaultValidatorOptions
          );
        });*/
        _this.formFields = _this.onlyFields(fields);
        return _this;
    }
    Object.defineProperty(DynamicFormGroup.prototype, "externalErrors", {
        get: /**
         * @return {?}
         */
        function () {
            return this._externalErrors;
        },
        // Getters & Setters
        set: 
        // Getters & Setters
        /**
         * @param {?} externalErrors
         * @return {?}
         */
        function (externalErrors) {
            this._externalErrors = externalErrors;
            this.validate();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynamicFormGroup.prototype, "validatorOptions", {
        get: /**
         * @return {?}
         */
        function () {
            return this._validatorOptions;
        },
        set: /**
         * @param {?} validatorOptions
         * @return {?}
         */
        function (validatorOptions) {
            this._validatorOptions = validatorOptions;
            this.validate();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynamicFormGroup.prototype, "object", {
        get: /**
         * @return {?}
         */
        function () {
            return this.getObject();
        },
        set: /**
         * @param {?} object
         * @return {?}
         */
        function (object) {
            this.setObject(object);
        },
        enumerable: true,
        configurable: true
    });
    // Public API
    // Public API
    /**
     * @param {?=} externalErrors
     * @param {?=} validatorOptions
     * @return {?}
     */
    DynamicFormGroup.prototype.validate = 
    // Public API
    /**
     * @param {?=} externalErrors
     * @param {?=} validatorOptions
     * @return {?}
     */
    function (externalErrors, validatorOptions) {
        this.validateAsync(externalErrors, validatorOptions).then((/**
         * @return {?}
         */
        function () { }), (/**
         * @param {?} error
         * @return {?}
         */
        function (error) {
            throw error;
        }));
    };
    /**
     * @param {?=} externalErrors
     * @param {?=} validatorOptions
     * @return {?}
     */
    DynamicFormGroup.prototype.validateAsync = /**
     * @param {?=} externalErrors
     * @param {?=} validatorOptions
     * @return {?}
     */
    function (externalErrors, validatorOptions) {
        return __awaiter(this, void 0, void 0, function () {
            var result, validationErrors, allErrors, usedForeverInvalid, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (externalErrors === undefined) {
                            externalErrors = cloneDeep(this._externalErrors);
                        }
                        if (validatorOptions === undefined) {
                            validatorOptions = cloneDeep(this._validatorOptions);
                        }
                        if (!externalErrors) {
                            externalErrors = {};
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, validate(this.object, validatorOptions)];
                    case 2:
                        result = _a.sent();
                        validationErrors = this.transformValidationErrors(result);
                        allErrors = this.mergeErrors(externalErrors, validationErrors);
                        this.markAsInvalidForExternalErrors(externalErrors);
                        this.setCustomErrors(allErrors);
                        // todo: refactor, invalidate form if exists any allErrors
                        usedForeverInvalid = false;
                        if (Object.keys(allErrors).filter((/**
                         * @param {?} key
                         * @return {?}
                         */
                        function (key) { return key !== FOREVER_INVALID_NAME; })).length === 0 &&
                            this.get(FOREVER_INVALID_NAME)) {
                            this.removeControl(FOREVER_INVALID_NAME);
                            usedForeverInvalid = true;
                        }
                        if (this.valid && Object.keys(allErrors).length > 0 && !this.get(FOREVER_INVALID_NAME)) {
                            this.addControl(FOREVER_INVALID_NAME, new FormControl('', [foreverInvalid]));
                            usedForeverInvalid = true;
                        }
                        if (usedForeverInvalid) {
                            this.updateValueAndValidity({
                                onlySelf: true,
                                emitEvent: false
                            });
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        throw error_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param {?} allErrors
     * @return {?}
     */
    DynamicFormGroup.prototype.setCustomErrors = /**
     * @param {?} allErrors
     * @return {?}
     */
    function (allErrors) {
        this.formErrors = allErrors;
        this.customValidateErrors.next(this.formErrors);
        this.nativeValidateErrors.next(this.collectErrors(this));
    };
    /**
     * @private
     * @param {?} control
     * @param {?=} isRoot
     * @return {?}
     */
    DynamicFormGroup.prototype.collectErrors = /**
     * @private
     * @param {?} control
     * @param {?=} isRoot
     * @return {?}
     */
    function (control, isRoot) {
        var _this = this;
        if (isRoot === void 0) { isRoot = true; }
        if (control.controls) {
            return __assign({}, (isRoot ? this.errors : {}), Object.entries(control.controls).reduce((/**
             * @param {?} acc
             * @param {?} __1
             * @return {?}
             */
            function (acc, _a) {
                var _b = __read(_a, 2), key = _b[0], childControl = _b[1];
                var _c;
                /** @type {?} */
                var childErrors = _this.collectErrors(childControl, false);
                if (childErrors && key !== 'foreverInvalid' && Object.keys(childErrors).length > 0) {
                    acc = __assign({}, acc, (_c = {}, _c[key] = __assign({}, (acc && acc[key] ? acc[key] : {}), childErrors), _c));
                }
                return acc;
            }), null));
        }
        else {
            return control.errors;
        }
    };
    /**
     * @return {?}
     */
    DynamicFormGroup.prototype.validateAllFormFields = /**
     * @return {?}
     */
    function () {
        var _this = this;
        Object.keys(this.controls).forEach((/**
         * @param {?} field
         * @return {?}
         */
        function (field) {
            /** @type {?} */
            var control = _this.get(field);
            // Control
            if (control instanceof FormControl) {
                control.markAsTouched({ onlySelf: true });
            }
            // Group: recursive
            else if (control instanceof DynamicFormGroup) {
                control.validateAllFormFields();
            }
            // Array
            else if (control instanceof FormArray) {
                for (var i = 0; i < ((/** @type {?} */ (control))).controls.length; i++) {
                    // Control in Array
                    if (((/** @type {?} */ (control))).controls[i] instanceof FormControl) {
                        ((/** @type {?} */ (((/** @type {?} */ (control))).controls[i]))).markAsTouched({ onlySelf: true });
                    }
                    // Group in Array: recursive
                    else if (((/** @type {?} */ (control))).controls[i] instanceof DynamicFormGroup) {
                        ((/** @type {?} */ (((/** @type {?} */ (control))).controls[i]))).validateAllFormFields();
                    }
                }
            }
        }));
    };
    /**
     * @return {?}
     */
    DynamicFormGroup.prototype.resetValidateAllFormFields = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.markAsInvalidForExternalErrors({});
        Object.keys(this.controls).forEach((/**
         * @param {?} field
         * @return {?}
         */
        function (field) {
            /** @type {?} */
            var control = _this.get(field);
            // Control
            if (control instanceof FormControl) {
                control.setErrors(undefined, { emitEvent: false });
                control.markAsUntouched({ onlySelf: true });
                control.markAsPristine({ onlySelf: true });
            }
            // Group: recursive
            else if (control instanceof DynamicFormGroup) {
                control.resetValidateAllFormFields();
            }
            // Array
            else if (control instanceof FormArray) {
                for (var i = 0; i < ((/** @type {?} */ (control))).controls.length; i++) {
                    // Control in Array
                    if (((/** @type {?} */ (control))).controls[i] instanceof FormControl) {
                        ((/** @type {?} */ (((/** @type {?} */ (control))).controls[i]))).setErrors(undefined, { emitEvent: false });
                        ((/** @type {?} */ (((/** @type {?} */ (control))).controls[i]))).markAsUntouched({ onlySelf: true });
                        ((/** @type {?} */ (((/** @type {?} */ (control))).controls[i]))).markAsPristine({ onlySelf: true });
                    }
                    // Group in Array: recursive
                    else if (((/** @type {?} */ (control))).controls[i] instanceof DynamicFormGroup) {
                        ((/** @type {?} */ (((/** @type {?} */ (control))).controls[i]))).resetValidateAllFormFields();
                    }
                }
            }
        }));
        this.setCustomErrors({});
    };
    /**
     * @template TClassModel
     * @param {?} object
     * @return {?}
     */
    DynamicFormGroup.prototype.classToClass = /**
     * @template TClassModel
     * @param {?} object
     * @return {?}
     */
    function (object) {
        return classToClass(object, { ignoreDecorators: true });
    };
    /**
     * @template TClassModel, Object
     * @param {?} cls
     * @param {?} plain
     * @return {?}
     */
    DynamicFormGroup.prototype.plainToClass = /**
     * @template TClassModel, Object
     * @param {?} cls
     * @param {?} plain
     * @return {?}
     */
    function (cls, plain) {
        return plainToClass(cls, plain, { ignoreDecorators: true });
    };
    /**
     * @param {?} externalErrors
     * @return {?}
     */
    DynamicFormGroup.prototype.setExternalErrorsAsync = /**
     * @param {?} externalErrors
     * @return {?}
     */
    function (externalErrors) {
        return __awaiter(this, void 0, void 0, function () {
            var error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._externalErrors = externalErrors;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.validateAsync()];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_2 = _a.sent();
                        throw error_2;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param {?} externalErrors
     * @return {?}
     */
    DynamicFormGroup.prototype.setExternalErrors = /**
     * @param {?} externalErrors
     * @return {?}
     */
    function (externalErrors) {
        this.setExternalErrorsAsync(externalErrors).then((/**
         * @return {?}
         */
        function () { }), (/**
         * @param {?} error
         * @return {?}
         */
        function (error) {
            throw error;
        }));
    };
    /**
     * @return {?}
     */
    DynamicFormGroup.prototype.getExternalErrors = /**
     * @return {?}
     */
    function () {
        return this._externalErrors;
    };
    /**
     * @return {?}
     */
    DynamicFormGroup.prototype.clearExternalErrors = /**
     * @return {?}
     */
    function () {
        this.setExternalErrors({});
    };
    /**
     * @return {?}
     */
    DynamicFormGroup.prototype.clearExternalErrorsAsync = /**
     * @return {?}
     */
    function () {
        return this.setExternalErrorsAsync({});
    };
    /**
     * @param {?} validatorOptions
     * @return {?}
     */
    DynamicFormGroup.prototype.setValidatorOptionsAsync = /**
     * @param {?} validatorOptions
     * @return {?}
     */
    function (validatorOptions) {
        return __awaiter(this, void 0, void 0, function () {
            var error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._validatorOptions = validatorOptions;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.validateAsync()];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_3 = _a.sent();
                        throw error_3;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param {?} validatorOptions
     * @return {?}
     */
    DynamicFormGroup.prototype.setValidatorOptions = /**
     * @param {?} validatorOptions
     * @return {?}
     */
    function (validatorOptions) {
        this.setValidatorOptionsAsync(validatorOptions).then((/**
         * @return {?}
         */
        function () { }), (/**
         * @param {?} error
         * @return {?}
         */
        function (error) {
            throw error;
        }));
    };
    /**
     * @return {?}
     */
    DynamicFormGroup.prototype.getValidatorOptions = /**
     * @return {?}
     */
    function () {
        return this._validatorOptions;
    };
    // Helpers
    // Helpers
    /**
     * @private
     * @param {?} fields
     * @return {?}
     */
    DynamicFormGroup.prototype.onlyFields = 
    // Helpers
    /**
     * @private
     * @param {?} fields
     * @return {?}
     */
    function (fields) {
        var _this = this;
        /** @type {?} */
        var newFields = {};
        if (fields !== undefined) {
            Object.keys(fields).forEach((/**
             * @param {?} key
             * @return {?}
             */
            function (key) {
                if (fields[key] instanceof DynamicFormGroup) {
                    // Group: recursive
                    newFields[key] = _this.onlyFields(((/** @type {?} */ (fields[key]))).formFields);
                }
                else {
                    // Array
                    if (fields[key] instanceof FormArray) {
                        if (((/** @type {?} */ (fields[key]))).controls[0] instanceof DynamicFormGroup) {
                            // Group within Array: recursive
                            newFields[key] = _this.onlyFields(((/** @type {?} */ (((/** @type {?} */ (fields[key]))).controls[0]))).formFields);
                        }
                        else {
                            // Control within Array
                            newFields[key] = ((/** @type {?} */ (fields[key]))).controls[0].value;
                        }
                    }
                    else {
                        // Handle Control
                        newFields[key] = fields[key];
                    }
                }
            }));
        }
        return newFields;
    };
    /**
     * @param {?} errors
     * @return {?}
     */
    DynamicFormGroup.prototype.transformValidationErrors = /**
     * @param {?} errors
     * @return {?}
     */
    function (errors) {
        var _this = this;
        /** @type {?} */
        var customErrors = {};
        errors.forEach((/**
         * @param {?} error
         * @return {?}
         */
        function (error) {
            if (error && error.constraints !== undefined) {
                Object.keys(error.constraints).forEach((/**
                 * @param {?} key
                 * @return {?}
                 */
                function (key) {
                    if (!customErrors[error.property]) {
                        customErrors[error.property] = [];
                    }
                    if (((/** @type {?} */ (customErrors[error.property]))).indexOf(error.constraints[key]) === -1) {
                        ((/** @type {?} */ (customErrors[error.property]))).push(error.constraints[key]);
                    }
                }));
            }
            if (error.children !== undefined && error.children.length) {
                customErrors[error.property] = _this.transformValidationErrors(error.children);
            }
        }));
        return customErrors;
    };
    /**
     * @private
     * @param {?=} externalErrors
     * @param {?=} validationErrors
     * @return {?}
     */
    DynamicFormGroup.prototype.mergeErrors = /**
     * @private
     * @param {?=} externalErrors
     * @param {?=} validationErrors
     * @return {?}
     */
    function (externalErrors, validationErrors) {
        /** @type {?} */
        var clonedExternalErrors = cloneDeep(externalErrors);
        return mergeWith(clonedExternalErrors, validationErrors, (/**
         * @param {?} objValue
         * @param {?} srcValue
         * @return {?}
         */
        function (objValue, srcValue) {
            if (canMerge()) {
                return objValue.concat(srcValue);
            }
            /**
             * @return {?}
             */
            function canMerge() {
                return (Array.isArray(objValue) &&
                    Array.isArray(srcValue) &&
                    objValue.filter((/**
                     * @param {?} objItem
                     * @return {?}
                     */
                    function (objItem) { return srcValue.indexOf(objItem) !== -1; })).length === 0);
            }
        }));
    };
    /**
     * @private
     * @param {?} errors
     * @param {?=} controls
     * @return {?}
     */
    DynamicFormGroup.prototype.markAsInvalidForExternalErrors = /**
     * @private
     * @param {?} errors
     * @param {?=} controls
     * @return {?}
     */
    function (errors, controls) {
        if (!controls) {
            controls = this.controls;
        }
        Object.keys(controls).forEach((/**
         * @param {?} field
         * @return {?}
         */
        function (field) {
            /** @type {?} */
            var control = controls[field];
            // Control
            if (control instanceof FormControl) {
                if (errors && errors[field]) {
                    control.setErrors({ externalError: true });
                }
                else {
                    if (control.errors && control.errors.externalError === true) {
                        control.setErrors(null);
                    }
                }
            }
            // Group
            else if (control instanceof DynamicFormGroup) {
                control.markAsInvalidForExternalErrors(errors && errors[field] ? ((/** @type {?} */ (errors[field]))) : {});
            }
            // Array
            else if (control instanceof FormArray) {
                for (var i = 0; i < ((/** @type {?} */ (control))).length; i++) {
                    // Control in Array
                    if (control[i] instanceof FormControl) {
                        if (errors && errors[i] && errors[i][field]) {
                            control[i].setErrors({ externalError: true });
                        }
                        else if (control[i].errors && control[i].errors.externalError === true) {
                            control[i].setErrors(null);
                        }
                    }
                    // Group in Array
                    else if (control[i] instanceof DynamicFormGroup) {
                        control[i].markAsInvalidForExternalErrors(errors && errors[i] && errors[i][field] ? ((/** @type {?} */ (errors[i][field]))) : {});
                    }
                }
            }
        }));
    };
    /**
     * Recursively gets all values from the form controls and all sub form group and array controls and returns it as
     * an object
     */
    /**
     * Recursively gets all values from the form controls and all sub form group and array controls and returns it as
     * an object
     * @private
     * @return {?}
     */
    DynamicFormGroup.prototype.getObject = /**
     * Recursively gets all values from the form controls and all sub form group and array controls and returns it as
     * an object
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        // Initialize the shape of the response
        /** @type {?} */
        var object = this._object
            ? this.classToClass(this._object)
            : this.factoryModel
                ? new this.factoryModel()
                : undefined;
        if (object !== undefined) {
            // Recursively get the value of all fields
            Object.keys(this.controls)
                .filter((/**
             * @param {?} name
             * @return {?}
             */
            function (name) { return name !== FOREVER_INVALID_NAME; }))
                .forEach((/**
             * @param {?} key
             * @return {?}
             */
            function (key) {
                // Handle Group
                if (_this.controls[key] instanceof DynamicFormGroup) {
                    object[key] = ((/** @type {?} */ (_this.controls[key]))).object;
                }
                // Handle Form Array
                else if (_this.controls[key] instanceof FormArray) {
                    // Initialize value
                    object[key] = [];
                    for (var i = 0; i < ((/** @type {?} */ (_this.controls[key]))).controls.length; i++) {
                        /** @type {?} */
                        var value = void 0;
                        if (((/** @type {?} */ (_this.controls[key]))).controls[i] instanceof DynamicFormGroup) {
                            // Recursively get object group
                            value = ((/** @type {?} */ (((/** @type {?} */ (_this.controls[key]))).controls[i]))).object;
                        }
                        else {
                            value = ((/** @type {?} */ (_this.controls[key]))).controls[i].value;
                        }
                        if (value && Object.keys(value).length > 0) {
                            object[key].push(value);
                        }
                    }
                }
                // Handle Control
                else {
                    object[key] = _this.controls[key].value;
                }
            }));
        }
        return this.factoryModel ? this.plainToClass(this.factoryModel, object) : object;
    };
    /**
     * Sets the value of every control on the form and recursively sets the values of the controls
     * on all sub form groups
     *
     * @param object the data to assign to all controls of the form group and sub groups
     */
    /**
     * Sets the value of every control on the form and recursively sets the values of the controls
     * on all sub form groups
     *
     * @private
     * @param {?} object the data to assign to all controls of the form group and sub groups
     * @return {?}
     */
    DynamicFormGroup.prototype.setObject = /**
     * Sets the value of every control on the form and recursively sets the values of the controls
     * on all sub form groups
     *
     * @private
     * @param {?} object the data to assign to all controls of the form group and sub groups
     * @return {?}
     */
    function (object) {
        var _this = this;
        if (object instanceof this.factoryModel) {
            this._object = this.classToClass(object); // Ensure correct type
        }
        else {
            this._object = this.plainToClass(this.factoryModel, (/** @type {?} */ (object))); // Convert to Model type
        }
        // Recursively set the value of all fields
        Object.keys(this.controls).forEach((/**
         * @param {?} key
         * @return {?}
         */
        function (key) {
            // Handle Group
            if (_this.controls[key] instanceof DynamicFormGroup) {
                ((/** @type {?} */ (_this.controls[key]))).object = _this._object ? _this._object[key] : {};
            }
            // Handle FormArray
            else if (_this.controls[key] instanceof FormArray) {
                /** @type {?} */
                var objectArray = _this._object ? _this._object[key] : [];
                /** @type {?} */
                var formArray = (/** @type {?} */ (_this.controls[key]));
                /** @type {?} */
                var isFormGroup = formArray.controls[0] instanceof DynamicFormGroup;
                /** @type {?} */
                var firstFormGroup = (/** @type {?} */ (formArray.controls[0]));
                /** @type {?} */
                var formControl = (/** @type {?} */ (formArray.controls[0]));
                // Clear FormArray while retaining the reference
                while (formArray.length !== 0) {
                    formArray.removeAt(0);
                }
                var _loop_1 = function (i) {
                    if (isFormGroup) {
                        // Create FormGroup
                        /** @type {?} */
                        var dynamicFormGroup_1 = new DynamicFormGroup(firstFormGroup.factoryModel, firstFormGroup.formFields);
                        dynamicFormGroup_1.setParent(_this);
                        /** @type {?} */
                        var classValidators = getClassValidators(firstFormGroup.factoryModel, firstFormGroup.formFields);
                        /** @type {?} */
                        var formGroup_1 = _this._fb.group(classValidators);
                        // Add all controls to the form group
                        Object.keys(formGroup_1.controls).forEach((/**
                         * @param {?} ctrlKey
                         * @return {?}
                         */
                        function (ctrlKey) {
                            dynamicFormGroup_1.addControl(ctrlKey, formGroup_1.controls[ctrlKey]);
                        }));
                        // Add a value change listener to the group. on change, validate
                        dynamicFormGroup_1.valueChanges.subscribe((/**
                         * @param {?} data
                         * @return {?}
                         */
                        function (data) {
                            dynamicFormGroup_1.validate(undefined, _this._validatorOptions);
                        }));
                        formArray.controls.push(dynamicFormGroup_1);
                        // Recusrively set the object value
                        ((/** @type {?} */ (formArray.controls[i]))).object =
                            _this._object && objectArray && objectArray[i] ? objectArray[i] : {};
                    }
                    else {
                        // Create control
                        /** @type {?} */
                        var controlValue = _this._object && objectArray && objectArray[i] ? objectArray[i] : undefined;
                        /** @type {?} */
                        var newFormControl = new FormControl(controlValue, formControl.validator);
                        newFormControl.setParent(_this);
                        // Add the control to the FormArray
                        formArray.controls.push(newFormControl);
                    }
                };
                for (var i = 0; i < objectArray.length; i++) {
                    _loop_1(i);
                }
            }
            // Handle Control
            else {
                /** @type {?} */
                var newObject = _this._object ? _this._object[key] : [];
                _this.controls[key].setValue(_this._object && newObject ? newObject : undefined);
            }
        }));
        this.objectChange.next(this._object);
    };
    return DynamicFormGroup;
}(FormGroup));
/**
 * @template TModel
 * @param {?} factoryModel
 * @param {?} fields
 * @param {?=} validatorOptions
 * @return {?}
 */
function getClassValidators(factoryModel, fields, validatorOptions) {
    // Get the validation rules from the object decorators
    /** @type {?} */
    var allValidationMetadatas = getFromContainer(MetadataStorage).getTargetValidationMetadatas(factoryModel, '');
    // Get the validation rules for the validation group: https://github.com/typestack/class-validator#validation-groups
    /** @type {?} */
    var validationGroupMetadatas = getFromContainer(MetadataStorage).getTargetValidationMetadatas(factoryModel, '', validatorOptions && validatorOptions.groups ? validatorOptions.groups : undefined);
    /** @type {?} */
    var formGroupFields = {};
    /** @type {?} */
    var validator = new Validator();
    // Loop through all fields in the form definition
    Object.keys(fields)
        .filter((/**
     * @param {?} key
     * @return {?}
     */
    function (key) { return key.indexOf('__') !== 0; }))
        .forEach((/**
     * @param {?} fieldName
     * @return {?}
     */
    function (fieldName) {
        // Conditional Validation for the field
        /** @type {?} */
        var conditionalValidations = [];
        validationGroupMetadatas.forEach((/**
         * @param {?} validationMetadata
         * @return {?}
         */
        function (validationMetadata) {
            if (isPropertyValidatorOfType(validationMetadata, fieldName, ValidationKeys.conditional.type)) {
                conditionalValidations.push(validationMetadata);
            }
        }));
        // All Nested Validation for the field
        /** @type {?} */
        var allNestedValidations = [];
        allValidationMetadatas.forEach((/**
         * @param {?} validationMetadata
         * @return {?}
         */
        function (validationMetadata) {
            if (isPropertyValidatorOfType(validationMetadata, fieldName, ValidationKeys.nested.type)) {
                allNestedValidations.push(validationMetadata);
            }
        }));
        // Nested Validation for the field for the requested class-validator group
        /** @type {?} */
        var nestedGroupValidations = [];
        validationGroupMetadatas.forEach((/**
         * @param {?} validationMetadata
         * @return {?}
         */
        function (validationMetadata) {
            if (isPropertyValidatorOfType(validationMetadata, fieldName, ValidationKeys.nested.type)) {
                nestedGroupValidations.push(validationMetadata);
            }
        }));
        /** @type {?} */
        var fieldDefinition = {
            data: formGroupFields[fieldName],
            validationFunctions: [],
            validationDefinitions: []
        };
        if (fieldDefinition.data === undefined) {
            fieldDefinition.data = fields[fieldName];
        }
        // TRY LINK EXISTS NATIVE VALIDATIONS, UNSTABLE !!!
        if (Array.isArray(fieldDefinition.data) &&
            fieldDefinition.data.length > 1 &&
            fieldDefinition.data.filter((/**
             * @param {?} validationFunction
             * @param {?} index
             * @return {?}
             */
            function (validationFunction, index) { return index > 0 && typeof validationFunction === 'function'; })).length > 0) {
            fieldDefinition.data
                .filter((/**
             * @param {?} validationFunction
             * @param {?} index
             * @return {?}
             */
            function (validationFunction, index) { return index > 0 && typeof validationFunction === 'function'; }))
                .forEach((/**
             * @param {?} validationFunction
             * @return {?}
             */
            function (validationFunction) { return fieldDefinition.validationFunctions.push(validationFunction); }));
            fieldDefinition.data = fieldDefinition.data[0];
        }
        validationGroupMetadatas.forEach((/**
         * @param {?} validationMetadata
         * @return {?}
         */
        function (validationMetadata) {
            if (validationMetadata.propertyName === fieldName &&
                validationMetadata.type !== ValidationKeys.conditional.type) {
                // Add all validation to the field except the @NestedValidation definition as
                // being part of the form would imply it is validated if any other rules are present
                if (validationMetadata.type !== ValidationKeys.nested.type) {
                    fieldDefinition.validationDefinitions.push(validationMetadata);
                }
                for (var typeKey in ValidationTypes) {
                    if (ValidationTypes.hasOwnProperty(typeKey)) {
                        // Handle Nested Validation
                        if (checkWithAllNestedValidations(allNestedValidations, nestedGroupValidations, fieldName)) {
                            if (isNestedValidate(validationMetadata, typeKey)) {
                                /** @type {?} */
                                var objectToValidate = fields[fieldName] instanceof DynamicFormGroup ? fields[fieldName].object : undefined;
                                /** @type {?} */
                                var nestedValidate = createNestedValidate(objectToValidate, validationMetadata);
                                setFieldData(fieldName, fieldDefinition, nestedValidate);
                            }
                        }
                        // Handle Custom Validation
                        if (isCustomValidate(validationMetadata, typeKey)) {
                            /** @type {?} */
                            var customValidation = createCustomValidation(fieldName, validationMetadata);
                            setFieldData(fieldName, fieldDefinition, customValidation);
                        }
                        // Handle remaining validation
                        if (isDynamicValidate(validationMetadata, typeKey)) {
                            /** @type {?} */
                            var dynamicValidate = createDynamicValidate(validationMetadata, conditionalValidations, fieldName);
                            setFieldData(fieldName, fieldDefinition, dynamicValidate);
                        }
                    }
                }
            }
        }));
        // Convert to a structure, angular understands
        if (fieldDefinition.data instanceof DynamicFormGroup || fieldDefinition.data instanceof FormArray) {
            formGroupFields[fieldName] = fieldDefinition.data;
        }
        else {
            formGroupFields[fieldName] = new DynamicFormControl(fieldDefinition);
        }
    }));
    return formGroupFields;
    // ******************************************************************************************
    // Local Helper functions to help make the main code more readable
    //
    /**
     * @param {?} objectToValidate
     * @param {?} validationMetadata
     * @return {?}
     */
    function createNestedValidate(objectToValidate, validationMetadata) {
        return (/**
         * @param {?} control
         * @return {?}
         */
        function (control) {
            /** @type {?} */
            var isValid = getValidateErrors(control, objectToValidate !== undefined ? objectToValidate : control.value, validatorOptions)
                .length === 0;
            return getIsValidResult(isValid, validationMetadata, 'nestedValidate');
        });
    }
    /**
     * @param {?} validationMetadata
     * @param {?} conditionalValidations
     * @param {?} fieldName
     * @return {?}
     */
    function createDynamicValidate(validationMetadata, conditionalValidations, fieldName) {
        return (/**
         * @param {?} control
         * @return {?}
         */
        function (control) {
            if (!control) {
                return null;
            }
            /** @type {?} */
            var isValid = control.parent && control.parent.value
                ? validator.validateValueByMetadata(control.value, validationMetadata)
                : true;
            if (!isValid && conditionalValidations.length > 0) {
                /** @type {?} */
                var validateErrors = setObjectValueAndGetValidationErrors(control, fieldName, validatorOptions);
                isValid = validateErrors.filter((/**
                 * @param {?} error
                 * @return {?}
                 */
                function (error) { return error.property === fieldName; })).length === 0;
            }
            return getIsValidResult(isValid, validationMetadata, 'dynamicValidate');
        });
    }
    /**
     * @param {?} fieldName
     * @param {?} validationMetadata
     * @return {?}
     */
    function createCustomValidation(fieldName, validationMetadata) {
        return (/**
         * @param {?} control
         * @return {?}
         */
        function (control) {
            /** @type {?} */
            var validateErrors = setObjectValueAndGetValidationErrors(control, fieldName, validatorOptions);
            /** @type {?} */
            var isValid = getAllErrors(validateErrors, fieldName).length === 0;
            return getIsValidResult(isValid, validationMetadata, 'customValidation');
        });
    }
    /**
     * @param {?} allNestedValidations
     * @param {?} nestedValidations
     * @param {?} key
     * @return {?}
     */
    function checkWithAllNestedValidations(allNestedValidations, nestedValidations, key) {
        return (allNestedValidations.length === nestedValidations.length ||
            ((fields[key] instanceof DynamicFormGroup || fields[key] instanceof FormArray) &&
                (allNestedValidations.length > 0 && nestedValidations.length === 0)));
    }
    /**
     * @param {?} validationMetadata
     * @param {?} typeKey
     * @return {?}
     */
    function isDynamicValidate(validationMetadata, typeKey) {
        return validationMetadata.type === ValidationTypes[typeKey] && validator[validationMetadata.type] !== undefined;
    }
    /**
     * marked with \@Validate(...)
     * https://github.com/typestack/class-validator#custom-validation-classes
     * @param {?} validationMetadata
     * @param {?} typeKey
     * @return {?}
     */
    function isCustomValidate(validationMetadata, typeKey) {
        return (isNotPropertyValidation(validationMetadata, typeKey) &&
            validationMetadata.type === ValidationKeys.custom.type &&
            typeKey === ValidationKeys.custom.typeKey);
    }
    /**
     * marked with \@ValidateNested()
     * https://github.com/typestack/class-validator#validating-nested-objects
     * @param {?} validationMetadata
     * @param {?} typeKey
     * @return {?}
     */
    function isNestedValidate(validationMetadata, typeKey) {
        return (isNotPropertyValidation(validationMetadata, typeKey) &&
            validationMetadata.type === ValidationKeys.nested.type &&
            typeKey === ValidationKeys.nested.typeKey);
    }
    /**
     * @param {?} validationMetadata
     * @param {?} typeKey
     * @return {?}
     */
    function isNotPropertyValidation(validationMetadata, typeKey) {
        return validationMetadata.type === ValidationTypes[typeKey] && validator[validationMetadata.type] === undefined;
    }
    /**
     * @param {?} fieldName
     * @param {?} fieldDefinition
     * @param {?} validationFunction
     * @return {?}
     */
    function setFieldData(fieldName, fieldDefinition, validationFunction) {
        /* todo: maybe not need, if enable this code, experemental mode not work
        if (fields[fieldName] instanceof DynamicFormGroup) {
          fields[fieldName].object = fields[fieldName].fields;
        }*/
        // Fill field data if empty
        if (fieldDefinition.data === undefined) {
            fieldDefinition.data = fields[fieldName];
        }
        fieldDefinition.validationFunctions.push(validationFunction);
    }
    /**
     * @param {?} validateErrors
     * @param {?} fieldName
     * @return {?}
     */
    function getAllErrors(validateErrors, fieldName) {
        return validateErrors.filter((/**
         * @param {?} error
         * @return {?}
         */
        function (error) {
            // Check for nested/child errors
            return (error.children.length && error.children.filter((/**
             * @param {?} children
             * @return {?}
             */
            function (children) { return children.property === fieldName; }))) ||
                error.property === fieldName;
        }));
    }
}
// ***************************************************************
// Global Helper functions
//
/**
 * @param {?} validationMetadata
 * @param {?} fieldName
 * @param {?} validationMetadataType
 * @return {?}
 */
function isPropertyValidatorOfType(validationMetadata, fieldName, validationMetadataType) {
    return validationMetadata.propertyName === fieldName && validationMetadata.type === validationMetadataType;
}
/**
 * @param {?} control
 * @param {?} key
 * @param {?} validatorOptions
 * @return {?}
 */
function setObjectValueAndGetValidationErrors(control, key, validatorOptions) {
    /** @type {?} */
    var object = control.parent instanceof DynamicFormGroup
        ? ((/** @type {?} */ (control.parent))).object
        : control.parent
            ? control.parent.value
            : {};
    if (object) {
        object[key] = control.value;
    }
    return getValidateErrors(control, object, validatorOptions);
}
/**
 * @param {?} control
 * @param {?} dataToValidate
 * @param {?} validatorOptions
 * @return {?}
 */
function getValidateErrors(control, dataToValidate, validatorOptions) {
    /** @type {?} */
    var validateErrors = control.parent && control.parent.value ? validateSync(dataToValidate, validatorOptions) : [];
    return validateErrors;
}
/**
 * @param {?} isValid
 * @param {?} validationMetadata
 * @param {?} errorType
 * @return {?}
 */
function getIsValidResult(isValid, validationMetadata, errorType) {
    var _a;
    return isValid
        ? null
        : (_a = {},
            _a[errorType] = {
                valid: false,
                type: validationMetadata.type
            },
            _a);
}
/** @type {?} */
var ValidationKeys = {
    nested: {
        type: 'nestedValidation',
        typeKey: 'NESTED_VALIDATION'
    },
    conditional: {
        type: 'conditionalValidation'
    },
    custom: {
        type: 'customValidation',
        typeKey: 'CUSTOM_VALIDATION'
    }
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DynamicFormBuilder = /** @class */ (function (_super) {
    __extends(DynamicFormBuilder, _super);
    function DynamicFormBuilder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // ******************
    // Public API
    // ******************
    // Public API
    /**
     * @template TModel
     * @param {?} factoryModel
     * @param {?=} controlsConfig
     * @param {?=} options
     * @return {?}
     */
    DynamicFormBuilder.prototype.group = 
    // ******************
    // Public API
    /**
     * @template TModel
     * @param {?} factoryModel
     * @param {?=} controlsConfig
     * @param {?=} options
     * @return {?}
     */
    function (factoryModel, controlsConfig, options) {
        var _this = this;
        // Process the group with the controlsConfig passed into extra instead. (What does this accomplish?)
        if (controlsConfig &&
            (isAbstractControlOptions(controlsConfig) ||
                isLegacyOrOpts(controlsConfig) ||
                isDynamicFormGroupConfig(controlsConfig)) &&
            !options) {
            return this.group(factoryModel, undefined, controlsConfig);
        }
        /** @type {?} */
        var extra = (/** @type {?} */ (options));
        /** @type {?} */
        var validators = null;
        /** @type {?} */
        var asyncValidators = null;
        /** @type {?} */
        var updateOn;
        if (extra != null) {
            if (isAbstractControlOptions(extra)) {
                // `extra` are `AbstractControlOptions`
                validators = extra.validators != null ? extra.validators : null;
                asyncValidators = extra.asyncValidators != null ? extra.asyncValidators : null;
                updateOn = extra.updateOn != null ? extra.updateOn : undefined;
            }
            if (isLegacyOrOpts(extra)) {
                // `extra` are legacy form group options
                validators = validators || [];
                validators = __spread(validators, [extra.validator != null ? extra.validator : null]);
                asyncValidators = asyncValidators || [];
                asyncValidators = __spread(asyncValidators, [extra.asyncValidator != null ? extra.asyncValidator : null]);
            }
            // Set default customValidatorOptions
            if (!isDynamicFormGroupConfig(extra)) {
                extra.customValidatorOptions = { validationError: { target: false } };
            }
        }
        /** @type {?} */
        var newControlsConfig;
        if (controlsConfig !== undefined) {
            newControlsConfig = (/** @type {?} */ (controlsConfig));
        }
        // experimental
        if (controlsConfig === undefined) {
            newControlsConfig = __assign({}, this.createEmptyObject(factoryModel));
            Object.keys(newControlsConfig).forEach((/**
             * @param {?} key
             * @return {?}
             */
            function (key) {
                if (canCreateGroup()) {
                    // recursively create a dynamic group for the nested object
                    newControlsConfig[key] = _this.group(newControlsConfig[key].constructor, undefined, __assign({}, (extra.customValidatorOptions ? { customValidatorOptions: extra.customValidatorOptions } : {}), { asyncValidators: asyncValidators,
                        updateOn: updateOn,
                        validators: validators }));
                }
                else {
                    if (canCreateArray()) {
                        if (newControlsConfig[key][0].constructor) {
                            // recursively create an array with a group
                            newControlsConfig[key] = _super.prototype.array.call(_this, newControlsConfig[key].map((/**
                             * @param {?} newControlsConfigItem
                             * @return {?}
                             */
                            function (newControlsConfigItem) {
                                return _this.group(newControlsConfigItem.constructor, undefined, __assign({}, (extra.customValidatorOptions ? { customValidatorOptions: extra.customValidatorOptions } : {}), { asyncValidators: asyncValidators,
                                    updateOn: updateOn,
                                    validators: validators }));
                            })));
                        }
                        else {
                            // Create an array of form controls
                            newControlsConfig[key] = _super.prototype.array.call(_this, newControlsConfig[key].map((/**
                             * @param {?} newControlsConfigItem
                             * @return {?}
                             */
                            function (newControlsConfigItem) { return _this.control(newControlsConfigItem); })));
                        }
                    }
                }
                /**
                 * @return {?}
                 */
                function canCreateGroup() {
                    /** @type {?} */
                    var candidate = newControlsConfig[key];
                    return (candidate &&
                        !Array.isArray(candidate) &&
                        candidate.constructor &&
                        typeof candidate === 'object' &&
                        (candidate.length === undefined ||
                            (candidate.length !== undefined && Object.keys(candidate).length === candidate.length)));
                }
                /**
                 * @return {?}
                 */
                function canCreateArray() {
                    if (Array.isArray(newControlsConfig[key]) === false) {
                        return false;
                    }
                    /** @type {?} */
                    var candidate = newControlsConfig[key][0];
                    return (candidate.constructor &&
                        typeof candidate === 'object' &&
                        (candidate.length === undefined ||
                            (candidate.length !== undefined && Object.keys(candidate).length === candidate.length)));
                }
            }));
        }
        // Remove empty
        validators = validators && validators.filter((/**
         * @param {?} validator
         * @return {?}
         */
        function (validator) { return validator; }));
        asyncValidators = asyncValidators && asyncValidators.filter((/**
         * @param {?} validator
         * @return {?}
         */
        function (validator) { return validator; }));
        // Create an Angular group from the top-level object
        /** @type {?} */
        var classValidators = getClassValidators(factoryModel, newControlsConfig, extra && extra.customValidatorOptions);
        /** @type {?} */
        var formGroup = _super.prototype.group.call(this, classValidators, __assign({}, (asyncValidators || {}), (updateOn || {}), (validators || {})));
        // Initialize the resulting group
        /** @type {?} */
        var dynamicFormGroup = new DynamicFormGroup(factoryModel, newControlsConfig, {
            asyncValidators: asyncValidators,
            updateOn: updateOn,
            validators: validators
        });
        // Add all angular controls to the resulting dynamic group
        Object.keys(formGroup.controls).forEach((/**
         * @param {?} key
         * @return {?}
         */
        function (key) {
            dynamicFormGroup.addControl(key, formGroup.controls[key]);
        }));
        // Add a listener to the dynamic group for value changes; on change, execute validation
        dynamicFormGroup.valueChanges.subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            dynamicFormGroup.validate(undefined, extra && extra.customValidatorOptions);
        }));
        return dynamicFormGroup;
    };
    // *******************
    // Helpers
    /**
     * Recursively creates an empty object from the data provided
     */
    // *******************
    // Helpers
    /**
     * Recursively creates an empty object from the data provided
     * @private
     * @template TModel
     * @param {?} factoryModel
     * @param {?=} data
     * @return {?}
     */
    DynamicFormBuilder.prototype.createEmptyObject = 
    // *******************
    // Helpers
    /**
     * Recursively creates an empty object from the data provided
     * @private
     * @template TModel
     * @param {?} factoryModel
     * @param {?=} data
     * @return {?}
     */
    function (factoryModel, data) {
        var _this = this;
        if (data === void 0) { data = {}; }
        /** @type {?} */
        var modifed = false;
        /** @type {?} */
        var object = factoryModel ? plainToClass(factoryModel, data) : data;
        /** @type {?} */
        var fields = Object.keys(object);
        fields.forEach((/**
         * @param {?} fieldName
         * @return {?}
         */
        function (fieldName) {
            if (object[fieldName] && object[fieldName].length !== undefined) {
                if (object[fieldName].length === 1 &&
                    Object.keys(object[fieldName][0]).length > 0 &&
                    object[fieldName][0].constructor) {
                    object[fieldName] = [_this.createEmptyObject(object[fieldName][0].constructor)];
                }
                if (object[fieldName].length === 0) {
                    data[fieldName] = [{}];
                    modifed = true;
                }
            }
            else {
                data[fieldName] = undefined;
            }
        }));
        if (modifed) {
            return this.createEmptyObject(factoryModel, data);
        }
        return object;
    };
    return DynamicFormBuilder;
}(FormBuilder));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { DynamicFormBuilder, DynamicFormControl, DynamicFormGroup, FOREVER_INVALID_NAME, foreverInvalid, getClassValidators, isAbstractControlOptions, isDynamicFormGroupConfig, isLegacyOrOpts };
//# sourceMappingURL=ngx-dynamic-form-builder.js.map
